import React from 'react'
import { Switch, Route } from "react-router-dom"
import TourPackages from './tour-packages.page'
import CreateTourPackage from './create/create.page'
import EditTourPackage from './edit/edit.page'

const TourPackageController = () => {
    return (
        <Switch>
            <Route path="/content/tour-packages/edit/:id" component={EditTourPackage} />
            <Route path="/content/tour-packages/create" component={CreateTourPackage} />
            <Route exact path="/content/tour-packages" component={TourPackages} />
        </Switch>
    )
}

export default TourPackageController
